import React, { useEffect, useState } from 'react'
import {Col, Row} from 'react-bootstrap'
import Modal from 'react-modal'

import {ButtonHeader} from '../Button/ButtonHeader'
import ByondGrid2 from '../../customGrid/CustomGrid'
import StateStorage from '../../utils/StateStorage'

Modal.setAppElement('#root')

export const ModalWithGrid = ({
  showModal,
  handleShowModal,
  title,
  subtitle,
  endpoint,
  metadata,
  actions,
  match,
  customFilters,
  addParams
}) => {

  const [endpointWithParams, setEndpointWithParams] = useState(endpoint)
  const [modalStyle, setModalStyle] = useState({
    content: {
      display: 'flex',
      flexDirection: 'column',
      position: 'absolute',
      borderRadius: 15,
      overflow: 'hidden',
      top: '9%',
      height: '83vh'
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.329)'
    }
  })

  const sidebarIsCollapsed = StateStorage.get('SIDEBAR_COLLAPSE')

  const getModalDimensions = () => {
    modalStyle.content.width = sidebarIsCollapsed ? '60px - 100vw' : '230px - 100vw'
    modalStyle.content.right = sidebarIsCollapsed ? '8px' : '8px'
    modalStyle.content.left = sidebarIsCollapsed ? '60px' : '240px'

    let newStyle = { ...modalStyle }
    setModalStyle(newStyle)
  }

  const getEndpoint = () => {
    const params = new URLSearchParams({})

    addParams && addParams(params)

    if (/\?/.test(endpoint)) {
      setEndpointWithParams(`${endpoint}&${params.toString()}`)
    } else {
      setEndpointWithParams(`${endpoint}?${params.toString()}`)
    }
  }

  useEffect(() => {
    getModalDimensions()
  }, [sidebarIsCollapsed])

  useEffect(() => {
    getEndpoint()
  }, [addParams])

  return (
      <Row>
        <Modal shouldCloseOnOverlayClick onRequestClose={handleShowModal} isOpen={showModal} style={modalStyle}>
          <Row className="mb-4">
            <Col md={10}>
              <h4 >{ title }</h4>
              <h5 style={styles.subtitle}>{subtitle}</h5>
            </Col>
            {
              actions && (
                <Col md={1}>
                  <h4>Ações</h4>
                  { actions }
                </Col>
              )
            }
            <Col md={1} style={{textAlign: 'right'}}>
              <ButtonHeader
                  title="Fechar modal"
                  icon="times-circle fa-2x"
                  style={{
                    border: 'none',
                    outline: 'none',
                    backgroundColor: 'transparent'
                  }}
                  iconStyle={{color: '#666666'}}
                  onClick={() => handleShowModal(false)}
              />
            </Col>
          </Row>
          {
            customFilters && (
              <Row className="flex-row-reverse">
                <Col className="pull-right mr-5">
                  {
                    customFilters
                  }
                </Col>
              </Row>
            )
          }
          <Row>
            <ByondGrid2
              endpoint={endpointWithParams}
              match={match}
              metadata={metadata}
              tableStyle={{height: '65vh'}}
            />
          </Row>
        </Modal>
      </Row>
  )
}

const styles = {
  subtitle: {
    fontWeight: '500',
    color: '#818E9B',
  }
}



// WEBPACK FOOTER //
// ./src/component/Modal/ModalWithGrid.js